/* eslint-disable max-len */
import React from 'react';
import Icon from 'react-icon-base';

const DmiEye = (props) => (
  <Icon viewBox="0 0 20 16" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M0-2h20v20H0z" />
      <path
        fill="currentColor"
        fillRule="nonzero"
        d="M10 .222C5.455.222 1.573 3.447 0 8c1.573 4.553 5.455 7.778 10 7.778S18.427 12.553 20 8C18.427 3.447 14.545.222 10 .222zM10 13c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8C8.34 5 7 6.34 7 8s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
      />
    </g>
  </Icon>
);

export default DmiEye;
